import Stack from '@mui/material/Stack';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import ExpenseFilter from './components/ExpenseFilter';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export default function Expense({ CRO }) {
  const dispatch = useDispatch();

  // redux states

  // normal react state

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [expType, setExpType] = useState({
    id: '',
    name: '',
  });

  // mounting only effect
  useEffect(() => {}, [dispatch]);

  return (
    <GlobalWrapper title={'Expense'}>
      <Stack gap={1}>
        <ExpenseFilter
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          CRO={CRO}
          expType={expType}
          setExpType={setExpType}
        />
        <GlobalTable headers={[]} rows={[]} loading={false} />
      </Stack>
    </GlobalWrapper>
  );
}
